import React from 'react';
import { Link } from 'react-router-dom';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import './ProjectPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2011-01-31', displayDate: 'January 31, 2011' };

const NavLinks = () => (
  <p className="text-small text-italic text-gray">
    <a href="#top">Go to top</a> | <a href="#contents">Go to contents</a>
  </p>
);

const YtCrawlerRelease2Page = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  return (
    <div className="project-page" id="top">
      <p>
        This page describes the upcoming YTCrawler software release 2.{' '}
        <Link to="/projects/ytcrawler/release1">Go here</Link> for information related to release 1.
      </p>
      <h1 className="title">YTCrawler Release 2</h1>
      <p>
        The YtCrawler software for crawling metadata from the video sharing site YouTube, is a project in progress and
        the software on this page is subject to change. There are no guarantees for this software and you can use it
        on your own risk. YTCrawler is free software and is licensed under the terms of{' '}
        <a href="http://www.gnu.org/licenses/gpl.html" target="_blank" rel="noopener noreferrer">
          GNU General Public License
        </a>
        .
      </p>
      <p>
        This page is a user guide to YtCrawler. <Link to="/contact">Contact me</Link> to get the installation package
        and/or source code. A developer guide is not currently available.
      </p>

      <h1 id="contents">On This Page</h1>
      <ol type="I">
        <li>
          <a href="#s1">The Basics</a>
          <ol>
            <li><a href="#s11">What is YtCrawler?</a></li>
            <li><a href="#s12">Architecture and Main Components</a></li>
            <li><a href="#s13">Changes from Release 1</a></li>
          </ol>
        </li>
        <li><a href="#s2">Installation and System Requirements</a></li>
        <li>
          <a href="#s3">The Administration Console</a>
          <ol>
            <li>
              <a href="#s31">Database Configuration</a>
              <ol type="a">
                <li><a href="#s31a">Adding and Removing a Database</a></li>
                <li><a href="#s31b">Setting the Primary Database</a></li>
                <li><a href="#s31c">Database Reconfiguration</a></li>
                <li><a href="#s31d">Database Usage and Testing</a></li>
                <li><a href="#s31e">Taking a Database Offline</a></li>
                <li><a href="#s31f">Database Tools</a></li>
              </ol>
            </li>
            <li>
              <a href="#s32">Crawler Configuration</a>
              <ol type="a">
                <li><a href="#s32a">Global Settings</a></li>
                <li>
                  <a href="#s32b">Understanding Video Feeds</a>
                  <ol type="i">
                    <li><a href="#s32bi">Configuring Categories</a></li>
                    <li><a href="#s32bii">Configuring Feeds</a></li>
                  </ol>
                </li>
                <li><a href="#s32c">Slaves</a></li>
                <li><a href="#s32d">Database Tables</a></li>
              </ol>
            </li>
            <li>
              <a href="#s33">Crawler</a>
              <ol type="a">
                <li><a href="#s33a">Understanding the Crawling Types</a></li>
                <li><a href="#s33b">Crawling Videos</a></li>
                <li><a href="#s33c">Crawling Snapshots</a></li>
                <li><a href="#s33d">Crawl Post-Processing</a></li>
              </ol>
            </li>
            <li>
              <a href="#s34">Data Inspection</a>
              <ol type="a">
                <li><a href="#s34a">Raw Data</a></li>
                <li><a href="#s34b">Statistical Data</a></li>
                <li><a href="#s34c">Data Tools</a></li>
              </ol>
            </li>
          </ol>
        </li>
        <li><a href="#s4">The Slave</a></li>
      </ol>

      <h1 id="s1">I. The Basics</h1>
      <p>In this chapter you will learn the basics of the YtCrawler software:</p>
      <ul>
        <li>What is SimStream and what are the main features?</li>
        <li>What is the software architecture and the basic components?</li>
        <li>How can you use the basic components to create a simple simulator?</li>
      </ul>
      <NavLinks />
      <h2 id="s11">I.1. What is YtCrawler?</h2>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h2 id="s12">I.2. Architecture and Main Components</h2>
      <div className="box">Coming soon!</div>
      <h2 className="text-small text-italic text-gray" id="s13">I.3. Changes from Release 1</h2>
      <div className="box">Coming soon!</div>
      <p><span className="text-small text-italic text-gray"><NavLinks /></span></p>
      <h1 id="s2">II. Installation and System Requirements</h1>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h1 id="s3">III. The Administration Console</h1>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h2 id="s31">III.1. Database Configuration</h2>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31a">III.1.a. Adding and Removing a Database</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31b">III.1.b. Setting the Primary Database</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31c">III.1.c. Database Reconfiguration</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31d">III.1.d. Database Usage and Testing</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31e">III.1.e. Taking a Database Offline</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s31f">III.1.f. Database Tools</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h2 id="s32">III.2. Crawler Configuration</h2>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s32a">III.2.a. Global Settings</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s32b">III.2.b. Understanding Video Feeds</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h4 id="s32bi">III.2.b.i. Configuring Categories</h4>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h4 id="s32bii">III.2.b.ii. Configuring Feeds</h4>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s32c">III.2.c. Slaves</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s32d">III.2.d. Database Tables</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h2 id="s33">III.3. Crawler</h2>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s33a">III.3.a. Understanding the Crawling Types</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s33b">III.3.b. Crawling Videos</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s33c">III.3.c. Crawling Snapshots</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s33d">III.3.d. Crawl Post-Processing</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h2 id="s34">III.4. Data Inspection</h2>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s34a">III.4.a. Raw Data</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s34b">III.4.b. Statistical Data</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h3 id="s34c">III.4.c. Data Tools</h3>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <h1 id="s4">IV. The Slave</h1>
      <div className="box">Coming soon!</div>
      <NavLinks />
      <p className="update">Last updated: January 31, 2011</p>
    </div>
  );
};

export default YtCrawlerRelease2Page;
